// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "63923b2d0e432cdf0a7ce468de735b04" + ".js";
};